export const DynamicContentModelsByType = new Map<string, any>([
  ['activity', 'DynamicContentActivity'],
  ['alphabet', 'DynamicContentAlphabet'],
  ['breaking-news', 'DynamicContentBreakingNews'],
  ['category', 'DynamicContentCategory'],
  ['event', 'DynamicContentEvent'],
  ['feedback', 'DynamicContentFeedback'],
  ['gallery', 'DynamicContentDefault'],
  ['gastronomy', 'DynamicContentGastronomy'],
  ['important-numbers', 'DynamicContentImportantNumbers'],
  ['information', 'DynamicContentDefault'],
  ['offer', 'DynamicContentOffer'],
  ['opening-hours', 'DynamicContentOpeningHours'],
  ['quiz', 'DynamicContentQuiz'],
  ['person', 'DynamicContentPerson'],
  ['pinboard', 'DynamicContentPinboard'],
  ['public-transport', 'DynamicContentPublicTransport'],
  ['restaurant', 'DynamicContentRestaurant'],
  ['screensaver', 'DynamicContentScreensaver'],
  ['social-media', 'DynamicContentSocialMedia'],
  ['ticker', 'DynamicContentTicker'],
  ['voting', 'DynamicContentVoting'],
  ['voucher', 'DynamicContentVoucher'],
  ['webcam', 'DynamicContentWebcam']
])
